import { DealRolePermissionsInput, DealRoleType } from "@/src/graphql/generated";
import { classNames } from "@/src/utils/cn";
import { getPermissionSections } from "./dealPermissionConfig";
import { PermissionLevelDropdown } from "./PermissionLevelDropdown";

export function DealPermissionsEditor(props: {
  permissions: DealRolePermissionsInput;
  roleType: DealRoleType;
  onChange: (permissions: DealRolePermissionsInput) => void;
  disabled?: boolean;
  compact?: boolean;
}) {
  const sections = getPermissionSections(props.roleType);

  return (
    <div className="flex flex-col ">
      {sections.map((section) => {
        const value =
          (props.permissions[section.key] as string | undefined) ??
          section.options[0].value;

        return (
          <div
            key={section.key}
            className={classNames(
              "flex items-center justify-between gap-x-4",
              props.compact ? "py-1.5" : "py-2.5",
            )}
          >
            <div className="flex items-center gap-x-1.5">
              <span className={classNames(
                "flex items-center justify-center",
                props.compact ? "w-4 h-4" : "w-5 h-5"
              )}>
                {section.icon}
              </span>
              <span
                className={classNames(
                  "font-semibold text-persian-990",
                  props.compact ? "text-xs" : "text-sm",
                )}
              >
                {section.label}
              </span>
            </div>
            <PermissionLevelDropdown
              options={section.options}
              value={value}
              onChange={(newValue) =>
                props.onChange({ ...props.permissions, [section.key]: newValue })
              }
              disabled={props.disabled}
            />
          </div>
        );
      })}
    </div>
  );
}
